import { createApp } from 'vue';
import App from './App.vue';
import BaseCardVue from './components/UI/BaseCard.vue';
import BaseButton from './components/UI/BaseButton.vue';
import BaseDialog from './components/UI/BaseDialog.vue';
const app = createApp(App);

app.component('base-card-vue', BaseCardVue);
app.component('base-button-vue', BaseButton);
app.component('base-dialog-vue', BaseDialog);
app.mount('#app');
// createApp({}).mount('#app');
